import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SectionHead } from "./Shared";

export const FAQSection = ({ faqs, overline = "Common Questions", title = "Frequently asked questions", bg = "bg-[#F8FAFC]" }) => (
  <section className={`py-24 md:py-32 ${bg}`} data-testid="faq-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-5 gap-12">
      <div className="lg:col-span-2">
        <SectionHead overline={overline} title={title} />
      </div>
      <div className="lg:col-span-3">
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem key={f.q} value={`faq-${i}`} className="border-b border-slate-200">
              <AccordionTrigger
                className="text-left font-heading font-bold text-base md:text-lg text-[#0A121F] hover:no-underline py-5"
                data-testid={`faq-trigger-${i}`}
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm md:text-base text-slate-600 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);
